import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const LoginSendCode = () => {
    return (
        <div id="send-code-login-page">
            <div className="title-login xmb-5 xpx-2">
                <span>کد تایید را وارد نمایید</span>
            </div>
            <div className="description-login-page xmb-6 xpx-2">
                <span>کد ۵ رقمی پیامک شده به موبایل‌تان را وارد کنید.</span>
            </div>
            <div className="input-log-in position-relative xmb-6">
                <input type="text" className="form-control input-normal" id="default-phone-login-page"
                       disabled/>
                <div className="phone-icon position-absolute">
                    <IconName name="phone" className="icon"/>
                </div>
                <div className="change-code position-absolute" id="change-phone-login-page"><span>ویرایش</span>
                </div>
            </div>
            <div className="code xmb-6 xmb-md-8">
                <fieldset className="number-code-login-page" id="parent-input-code-login">
                    <input type="number" name='code' id="first-box-code" className='code-input-login-page form-control'
                           maxLength="1" placeholder="___" required/>
                    <input type="number" name='code' className='code-input-login-page form-control' maxLength="1"
                           placeholder="___" required/>
                    <input type="number" name='code' className='code-input-login-page form-control' maxLength="1"
                           placeholder="___" required/>
                    <input type="number" name='code' className='code-input-login-page form-control' maxLength="1"
                           placeholder="___" required/>
                    <input type="number" name='code' className='code-input-login-page form-control' maxLength="1"
                           placeholder="___" required/>
                </fieldset>
            </div>
            <div className="button-log-in-code xmb-6">
                <button id="get-code-login-page" disabled={true}>ارسال مجدد کد تا <span id="timer-send-code-login-page"
                                                                                   className="timer-code-login">00:00</span> دیگر
                </button>
            </div>
            <div className="log-in-password-button xmt-6 xmb-2 text-center">
                <span className="open-password" id="go-login-password-page">ورود با رمز عبور</span>
            </div>
        </div>
    );
};

export default LoginSendCode;
